import React from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function FeedBackButton()
{
    return (
        <a
            className="tw-right-0 tw-transition-all tw-fixed tw-bottom-0 tw-z-50 tw-group"
            href="mailto:operations@ultimatejetvacations.com?subject=Dashboard%20Feedback"
            target="_blank"
        >
            <div className="group-hover:tw-block tw-hidden max-sm:group-hover:tw-hidden tw-absolute tw-right-full tw-whitespace-nowrap tw-top-2 tw-bg-neutral-800 tw-text-white tw-opacity-70 tw-px-4 tw-py-2 tw-rounded">
                Click here to request new features or give us feedback about the dashboard.
            </div>
            <FontAwesomeIcon
                className="tw-p-2 tw-block tw-cursor-pointer tw-w-6 tw-h-6 tw-rounded-md tw-m-2 tw-bg-ivory-background tw-text-black"
                icon={faEnvelope}
            />
        </a>
    );
}

export default FeedBackButton;
